export default "__VITE_ASSET__d6ce2aa1__"